var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.875V11.375M3.25 6.5216C3.60356 6.5 4.03944 6.5 4.6 6.5H9.4C9.96055 6.5 10.3964 6.5 10.75 6.5216M3.25 6.5216C2.80876 6.54853 2.49572 6.60912 2.22852 6.74525C1.80515 6.96095 1.46095 7.30512 1.24524 7.7285C1 8.20985 1 8.83985 1 10.1V11.15C1 12.4102 1 13.0401 1.24524 13.5215C1.46095 13.9449 1.80515 14.2891 2.22852 14.5048C2.70982 14.75 3.33988 14.75 4.6 14.75H9.4C10.6601 14.75 11.2901 14.75 11.7715 14.5048C12.1949 14.2891 12.539 13.9449 12.7547 13.5215C13 13.0401 13 12.4102 13 11.15V10.1C13 8.83985 13 8.20985 12.7547 7.7285C12.539 7.30512 12.1949 6.96095 11.7715 6.74525C11.5043 6.60912 11.1912 6.54853 10.75 6.5216M3.25 6.5216V5C3.25 2.92893 4.92893 1.25 7 1.25C9.07105 1.25 10.75 2.92893 10.75 5V6.5216",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/LockIcon.f8ae32975cd41e1baed89a2b7df0834a.svg";
export { ForwardRef as ReactComponent };